<template>
    <div style="display: contents;">
        <v-icon 
            :name="getProp('iconName')"
            :scale="getProp('iconScale')"
            :animation="getProp('iconAnimation')"
            :speed="getProp('iconSpeed')"
            :hover="getProp('iconHover')"
            :flip="getProp('iconFlip')"
            :fill="getProp('iconFill')"
            :label="getProp('iconLabel')"
            :title="getProp('iconTitle')"
            :inverse="getProp('iconInverse')"
            :style="iconSizeStyle"
            v-if="!lodash.has(cp, 'props.iconText')"
        >
        </v-icon>
        
        <div v-if="lodash.has(cp, 'props.iconBadgeClass')"
            :class="'icon-status ' + getProp('iconBadgeClass')"
        >
        </div>
        
        <b-avatar 
            variant="primary" 
            :text="getProp('iconText')"
            v-if="lodash.has(cp, 'props.iconText')"
        >
        </b-avatar>
        
    </div>
</template>

<script>
    
    import ComponentInternalMixin from '../../core/ComponentInternalMixin';
    import { BAvatar } from 'bootstrap-vue';

    export default {
        name: 'ClicIconInterno',
        mixins: [ComponentInternalMixin],
        components: { BAvatar },

        computed: {

            /*
              Teto explícito em px para o ícone.

              O oh-vue-icons normaliza todo ícone numa caixa de 16 multiplicada
              pela `scale`, então 16 * scale é exatamente a maior dimensão que o
              ícone pode ter. Usar max-width/max-height (e não width/height)
              mantém a proporção de ícones não quadrados intacta e não altera o
              tamanho atual em nenhum navegador — só impede que o ícone estoure
              quando o motor calcula o tamanho de outra forma
              (WebKit / Safari 26.4+ e iOS 27).
            */
            iconSizeStyle() {
                const tamanho = (Number(this.getProp('iconScale')) || 1) * 16;

                return {
                    maxWidth: `${tamanho}px`,
                    maxHeight: `${tamanho}px`,
                };
            },

        },
    }
    
</script>


<style lang="scss" scoped>
    
  .icon-status:after {
    position: absolute;
    border-radius: 50%;
    right: 0;
    top:-5px;
    height: 10px;
    width: 10px;
    border: 1px solid #fff;
  }

  /*
    Não usar `max-width: fit-content` aqui: em elementos substituídos (SVG)
    com aspect-ratio o `fit-content` passou a ser calculado pelo tamanho
    transferido pela razão de aspecto (WebKit / Safari 26.4+ e iOS 27),
    o que estourava o tamanho do ícone. O tamanho vem dos atributos
    width/height do próprio SVG; aqui só impedimos que o flex o estique.
  */
  svg{
    flex: none;
    align-self: center;
  }
 
 
</style>
